var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4477 2.70001C1.2577 2.70001 1.0677 2.77001 0.917695 2.92001C0.627695 3.21001 0.627695 3.69001 0.917695 3.98001L4.1177 7.18001C4.2777 7.34001 4.4877 7.42001 4.7177 7.40001C4.9377 7.38001 5.1377 7.26001 5.2677 7.07001L6.3577 5.43001L9.9077 8.98001C10.1977 9.27001 10.6777 9.27001 10.9677 8.98001C11.2577 8.69001 11.2577 8.21001 10.9677 7.92001L6.7677 3.72001C6.6077 3.56001 6.3977 3.48001 6.1677 3.50001C5.9477 3.52001 5.7477 3.64001 5.6177 3.83001L4.5277 5.47001L1.9777 2.92001C1.8277 2.77001 1.6377 2.70001 1.4477 2.70001Z",
    fill: "#EF2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4473 5.70142C10.0373 5.70142 9.69727 6.04142 9.69727 6.45142V7.70142H8.44727C8.03727 7.70142 7.69727 8.04142 7.69727 8.45142C7.69727 8.86142 8.03727 9.20142 8.44727 9.20142H10.4473C10.8573 9.20142 11.1973 8.86142 11.1973 8.45142V6.45142C11.1973 6.04142 10.8573 5.70142 10.4473 5.70142Z",
    fill: "#EF2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.8bdcddbadc45be07871367b3bd737f2f.svg";
export { ForwardRef as ReactComponent };